import { SalesOrderItemType } from '../constants/sales-order-item-type.js';
/** Returns the family a line type belongs to, or `null` if the type is outside the mixing rule. */
export function lineFamilyOf(typeId) {
    switch (typeId) {
        case SalesOrderItemType.SAMPLE:
            return 'sample';
        case SalesOrderItemType.SALE:
        case SalesOrderItemType.PROMO:
            return 'sales';
        default:
            return null;
    }
}
//# sourceMappingURL=line-family.js.map